import { render } from "./ComicsOverlay.vue?vue&type=template&id=84e2264c&scoped=true"
import script from "./ComicsOverlay.vue?vue&type=script&lang=js"
export * from "./ComicsOverlay.vue?vue&type=script&lang=js"

import "./ComicsOverlay.vue?vue&type=style&index=0&id=84e2264c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/logexpo/logexpo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84e2264c"]])

export default __exports__